import React from 'react';
import PropTypes from 'prop-types';

function ChevronRightIcon({ className = '', ...props }) {
  return (
    <svg fill='none' stroke='currentColor' viewBox='0 0 24 24' className={className} {...props}>
      <path d='m9 18 6-6-6-6' />
    </svg>
  );
}

ChevronRightIcon.propTypes = {
  className: PropTypes.string,
};

export default ChevronRightIcon;
